import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import urlTemplate from 'url-template';
import type { MmResponse } from 'src/apis/iip-service/types';
import type { MmsRequest } from 'src/apis/iip-service/use-mms';
import { useAxios } from 'src/hooks/use-axios';

type HookProps = {
  mmsRequest: MmsRequest;
};

type RequestOptions = {
  url: string;
};

export const useMm = ({ mmsRequest }: HookProps) => {
  const { maintenanceMessageId } = useParams<{
    maintenanceMessageId: string;
  }>();
  const request = useAxios(
    (axios, baseConfig, { url }: RequestOptions) => {
      return axios.request<MmResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!mmsRequest.response) return;
    const url = urlTemplate
      .parse(mmsRequest.response.data._links.instance.href)
      .expand({ maintenanceMessageId });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [mmsRequest.response, maintenanceMessageId]);

  return request;
};

export type MmRequest = ReturnType<typeof useMm>;
